import styles from './button.module.css'

export const buttonSize = {
    large: styles.buttonLarge,
    medium: styles.buttonMedium,
    small: styles.buttonSmall,
}
export const buttonVariant = {
    primary: 'primary',
    secondary: 'secondary',
}
export const buttonWidth = {
    content: styles.widthContent,
    full: styles.widthFull,
    fullMobile: styles.widthFullMob,
}
